<template>
  <div v-if="provider">
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <span
          class="provider-cell__wrapper"
          v-bind="attrs"
          v-on="on"
        >
          <router-link
            v-if="hasRanges"
            :to="providerRatesRoute"
            class="provider-cell__link"
          >
            <template v-if="moreThanOneDay">
              <v-chip color="red lighten-2">
                <v-icon
                  small
                  class="mr-1"
                >mdi-layers-outline</v-icon>
                {{ provider }}
                <v-icon
                  small
                  class="ml-1"
                >mdi-open-in-new</v-icon>
              </v-chip>
            </template>
            <template v-else>
              <span class="provider-cell__text">
                <v-icon
                  small
                  class="mr-1"
                >mdi-layers-outline</v-icon>
                {{ provider }}
                <v-icon
                  small
                  class="ml-1"
                >mdi-open-in-new</v-icon>
              </span>
            </template>
          </router-link>
          <template v-else>
            <v-chip
              v-if="moreThanOneDay"
              color="red lighten-2"
            >
              {{ provider }}
            </v-chip>
            <span v-else>
              {{ provider }}
            </span>
          </template>
        </span>
      </template>
      <div class="provider-cell__tooltip">
        <div class="provider-cell__tooltip-row">
          <span class="provider-cell__tooltip-label">Updated at:</span>
          <span>{{ updatedAt }}</span>
        </div>
        <template v-if="hasRanges">
          <v-divider class="my-2" />
          <div class="provider-cell__ranges">
            <div
              v-for="(range, index) in sortedRanges"
              :key="`provider-range-${index}`"
              class="provider-cell__range-row"
            >
              <span class="provider-cell__range-min">
                ≥ {{ formatAmount(range.minAmount, 2) }}
              </span>
              <span class="provider-cell__range-rate">
                {{ formatAmount(range.rate, 4) }}
              </span>
            </div>
          </div>
        </template>
      </div>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "ProviderCell",
  props: {
    provider: {
      type: String,
      default: ""
    },
    updatedAt: {
      type: String,
      default: ""
    },
    rateRanges: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      moreThanOneDay: false
    };
  },
  computed: {
    hasRanges() {
      return Array.isArray(this.rateRanges) && this.rateRanges.length > 0;
    },
    providerRatesRoute() {
      return {
        name: "ProviderRates",
        query: {
          payoutPartnerName: this.provider
        }
      };
    },
    sortedRanges() {
      if (!this.hasRanges) {
        return [];
      }
      return [...this.rateRanges].sort((a, b) => {
        const aMin = Number(a?.minAmount ?? 0);
        const bMin = Number(b?.minAmount ?? 0);
        return aMin - bMin;
      });
    }
  },
  mounted() {
    const nowLocalZone = new Date();
    const nowUTC = new Date(
      nowLocalZone.getTime() + nowLocalZone.getTimezoneOffset() * 60000
    );
    const now = this.$moment(nowUTC);
    const end = this.$moment(this.updatedAt);
    const duration = this.$moment.duration(now.diff(end));
    const days = duration.asDays();
    if (days >= 1) {
      this.moreThanOneDay = true;
    }
  },
  methods: {
    formatAmount(value, digits = 4) {
      if (value === null || value === undefined || value === "") {
        return "—";
      }
      const formatter = this.$options?.filters?.formatMoney;
      return formatter ? formatter(value, digits) : value;
    }
  }
};
</script>

<style lang="scss" scoped>
.provider-cell__wrapper {
  display: inline-flex;
  align-items: center;
}

.provider-cell__link {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  font-weight: 600;
  cursor: pointer;
}

.provider-cell__text {
  display: inline-flex;
  align-items: center;

  .v-icon {
    font-size: 16px;
  }
}

.provider-cell__link:hover {
  text-decoration: none;
}

.provider-cell__tooltip {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  min-width: 200px;
}

.provider-cell__tooltip-row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.provider-cell__tooltip-label {
  font-weight: 600;
}

.provider-cell__ranges {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.provider-cell__range-row {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}

.provider-cell__range-min {
  font-weight: 600;
  padding-right: 8px;
}
</style>
